import classNames from 'classnames'
import PropTypes from 'prop-types'
import * as React from 'react'

import {forwardProps} from '@base/react-utils'
import themeable from '@base/react-utils/themeable'

import Icon from '@base-uikit/icons/Icon'
import Tooltip from '@base-uikit/popovers/Tooltip'

import css from './InputErrorIndicator.css'

import t from 't'

@themeable(css)
class InputErrorIcon extends React.PureComponent {
  static propTypes = {
    message: PropTypes.string,
    focused: PropTypes.bool,
    active: PropTypes.bool,
  }

  render() {
    const {
      size,
      className,
      message = t('Invalid value', {
        screenshot: '',
        title: 'error message',
      }),
      tabIndex,
      focused,
      active,
    } = this.props
    const theme = this.theme
    const finalClassName = classNames([theme.InputErrorIcon, className])

    return (
      <Tooltip
        {...forwardProps(this)}
        {...(focused || active ? {opened: true} : undefined)}
        className={finalClassName}
        color="danger"
        content={message}
      >
        <Icon size={size} name="exclamation-sign" tabIndex={tabIndex} />
      </Tooltip>
    )
  }
}

export default InputErrorIcon
